module.exports = __webpack_public_path__ + "static/media/unsplash_VtKoSy_XzNU.cf1dbf18.png";